import React from "react";
import { AbsoluteFill, interpolate, spring, useCurrentFrame, useVideoConfig } from "remotion";
import { COLORS, FONTS, SPRING } from "./constants";
import { Backdrop, glow } from "./shared";

const UPGRADES = [
  { text: "Grounded answers", c: COLORS.neonGreen },
  { text: "Honest citations", c: COLORS.neonBlue },
  { text: "Diagrams that render", c: COLORS.neonPurple },
  { text: "Visible cost", c: COLORS.neonYellow },
];

export const Scene6TrustIntro: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps, durationInFrames } = useVideoConfig();

  const fade = interpolate(frame, [durationInFrames - 15, durationInFrames], [1, 0], {
    extrapolateLeft: "clamp",
    extrapolateRight: "clamp",
  });

  const pillSp = spring({ frame, fps, config: SPRING.gentle });
  const pillOp = interpolate(pillSp, [0, 1], [0, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });

  const titleSp = spring({ frame: frame - 10, fps, config: SPRING.bouncy });
  const titleOp = interpolate(titleSp, [0, 1], [0, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
  const titleSc = interpolate(titleSp, [0, 1], [0.7, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });

  const subSp = spring({ frame: frame - 22, fps, config: SPRING.gentle });
  const subOp = interpolate(subSp, [0, 1], [0, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });

  return (
    <AbsoluteFill style={{ background: COLORS.bg, opacity: fade, overflow: "hidden" }}>
      <Backdrop frame={frame} accent={COLORS.neonCyan} />

      <div style={{
        position: "absolute", inset: 0,
        display: "flex", flexDirection: "column",
        alignItems: "center", justifyContent: "center", gap: 30,
      }}>
        {/* Build-log pill */}
        <div style={{
          opacity: pillOp,
          fontSize: 22, fontFamily: FONTS.mono, fontWeight: 800,
          color: COLORS.neonCyan, letterSpacing: 5, textTransform: "uppercase",
          padding: "10px 26px", borderRadius: 30,
          background: `${COLORS.neonCyan}12`, border: `1.5px solid ${COLORS.neonCyan}`,
          textShadow: glow(COLORS.neonCyan),
        }}>
          Shipped this month · build log
        </div>

        {/* Title */}
        <div style={{
          opacity: titleOp, transform: `scale(${titleSc})`,
          fontSize: 84, fontFamily: FONTS.heading, fontWeight: 900,
          color: COLORS.textPrimary, textAlign: "center",
          letterSpacing: -2, lineHeight: 1.05,
          textShadow: `0 0 40px ${COLORS.neonCyan}55`,
        }}>
          Four upgrades to{" "}
          <span style={{ color: COLORS.neonGreen, textShadow: glow(COLORS.neonGreen, true) }}>
            trust the answer
          </span>
        </div>

        {/* Subtitle */}
        <div style={{
          opacity: subOp,
          fontSize: 32, fontFamily: FONTS.body, color: COLORS.textSecondary,
          textAlign: "center",
        }}>
          Same product. Here is the before and after.
        </div>

        {/* Teaser row of the four upgrades */}
        <div style={{ display: "flex", gap: 18, marginTop: 20, flexWrap: "wrap", justifyContent: "center" }}>
          {UPGRADES.map((u, i) => {
            const sp = spring({ frame: frame - 34 - i * 8, fps, config: SPRING.bouncy });
            const op = interpolate(sp, [0, 1], [0, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
            const sc = interpolate(sp, [0, 1], [0.6, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
            return (
              <div key={u.text} style={{
                opacity: op, transform: `scale(${sc})`,
                fontSize: 22, fontFamily: FONTS.mono, fontWeight: 700,
                color: u.c, padding: "10px 20px", borderRadius: 12,
                background: `${u.c}12`, border: `1.5px solid ${u.c}77`,
                textShadow: glow(u.c),
              }}>
                {u.text}
              </div>
            );
          })}
        </div>
      </div>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
